export default "__VITE_ASSET__EuGYUt_z__"